import Vue from 'vue'

const state = {
  limit: 20,
  isFetching: false,
  isMore: true,
  orders: null,
  currentOrderType: null
}

const actions = {
  LOAD_ORDER_LIST: ({commit}, queryData) => {
    commit('REQUEST_ORDER_LIST')
    const url = 'orders'
    Vue.http.get(url, {params: queryData})
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          (queryData.page > 0) ? commit('ADD_ORDER_LIST', response.orders) : commit('SET_ORDER_LIST', response.orders)
        } else {
          commit('SET_NO_DATA')
          if (queryData.page === 0) {
            commit('SET_ORDER_LIST', [])
          }
        }
      })
  }
}

const mutations = {
  REQUEST_ORDER_LIST: (state) => {
    state.isFetching = true
  },
  SET_NO_DATA: (state) => {
    state.isMore = false
  },
  SET_ORDER_LIST: (state, orders) => {
    state.orders = orders
    state.isFetching = false
    state.isMore = true
    if (orders.length < state.limit) {
      state.isMore = false
    }
  },
  ADD_ORDER_LIST: (state, orders) => {
    state.isFetching = false
    state.isMore = true
    for (let key in orders) {
      state.orders.push(orders[key])
    }
  },
  SET_EMPTY_ORDER: (state) => {
    state.orders = null
  },
  SET_CURRENT_ORDER_TYPE: (state, type) => {
    state.currentOrderType = type
  },
  UPDATE_ORDER_DATA: (state, data) => {
    if (state.orders && state.orders.length > 0) {
      state.orders[data.index][data.key] = data.value
    }
  }
}

const getters = {
  getState: state => {
    return state
  },
  isLoadMore: state => {
    return state.isFetching ? 'message.button.loading' : 'message.button.load_more'
  },
  getOrders: state => {
    return state.orders
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js